import React from 'react';
import LoadingIndicator from '@deliveroo/consumer-component-library/components/LoadingIndicator';
import styles from './styles.scss';

/**
 * An screen overlay to show while a request is made. Used for order self help for dynamic actions,
 * since we don't know what the next screen is, this is shown. Only in the example is it dismissable
 * by clicking. In reality, until the request succeeds or fails it won't disappear.
 */
function OrderHelpTemplateLoading() {
  return (
    <div className={styles.overlay}>
      <div className={styles['background-circle']}>
        <LoadingIndicator color="teal" size={18} />
      </div>
    </div>
  );
}

export default OrderHelpTemplateLoading;
